<template>
    <!-- <HeaderMenu ></HeaderMenu> -->
    <div class="container">
      <SettingUsers1View :datalists="datalists" :key="countRefresh"
      :dataBranchlists="dataBranchlists"
      :dataUsergrouplists="dataUsergrouplists"
      @onBackPageAfterSaveEvent="backPageAfterSave"></SettingUsers1View>
    </div>
</template>

<script>
// import axios from 'axios'
import { MyApiClient } from '../myjs/my-api-client.js'
// Bootstrap and jQuery libraries
import 'bootstrap/dist/css/bootstrap.min.css'
import 'jquery/dist/jquery.min.js'
// Datatable Modules
import 'datatables.net-dt/js/dataTables.dataTables'
import 'datatables.net-dt/css/jquery.dataTables.min.css'
import $ from 'jquery'
// import Swal from 'sweetalert2'
import SettingUsers1View from './SettingUsers1View.vue'
import { inject, ref } from 'vue'

export default {
  setup () {
    var globalCorpID = inject('corpID', ref(-1))
    var globalCorpName = inject('corpName', ref(''))
    var globalBranchID = inject('branchID', ref(-1))
    var globalUserID = inject('userID', ref(-1))
    var globalUserName = inject('userName', ref(''))
    var globalUserOfficialName = inject('userOfficialName', ref(''))
    var globalUserPosition = inject('userPosition', ref(''))
    return {
      globalCorpID, globalCorpName, globalBranchID, globalUserID, globalUserName, globalUserOfficialName, globalUserPosition
    }
  },
  name: 'Branch',
  components: {
    SettingUsers1View
  },
  data () {
    return {
      datalists: null,
      curRecord: {},
      action: 'new',
      countRefresh: 0,
      // รายชื่อสาขาทั้งหมด สำหรับเลือกใน Header Table
      dataBranchlists: null,
      // รายชื่อแผนก
      dataUsergrouplists: null
    }
  },
  mounted () {
    this.getUsergroupData()
    this.getBranchData()
    this.getData()
  },
  methods: {
    backPageAfterSave () {
      this.curRecord = {}
      this.action = 'new'
      // this.$nextTick(() => {
      //   $('#myUsersTable').DataTable()
      // })
      // ดึงข้อมูลรีเฟรชตารางใบสั่งตรวจ
      this.getData()
    },
    getUsergroupData () {
      MyApiClient.get('getdata/usergroup_all.php?C1=' + this.globalCorpID)
        .then((resp) => {
          this.dataUsergrouplists = resp.data.response
        })
        .catch((err) => {
          console.log(err.response)
        })
    },
    getBranchData () {
      MyApiClient.get('getdata/branch_all.php?C1=' + this.globalCorpID)
        .then((resp) => {
          this.dataBranchlists = resp.data.response
        })
        .catch((err) => {
          console.log(err.response)
        })
    },
    getData () {
    // axios.get('http://www.irissar.com/projects/parking/service/park_building/pb_like.php?key=%' + this.search_text + '%', {crossDomain: true})
      MyApiClient.get('getdata/users_all.php?C1=' + this.globalCorpID)
        .then((resp) => {
        //   console.log(resp.data.response)
          this.datalists = resp.data.response
          // setTimeout(function () { this.$refs.myUsersTable.DataTable() }, 0)
          setTimeout(function () { $('#myUsersTable').DataTable() }, 0)
          this.countRefresh++
        })
        .catch((err) => {
          console.log(err.response)
        })
    }
  }
}
</script>

<style>

</style>
